import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, take } from 'rxjs';
import { ApiEndpoints } from 'src/app/shared/common/apiPoint';
import { LookupItem } from 'src/app/shared/common/lookups.interface';
import { BaseResponse } from 'src/app/shared/interfaces/basr-response.interface';
import { BiDashboard } from '../interfaces/bi-dashboard.intrface';
import { BIUser } from '../interfaces/bi-user.inerfacce';
import { Dashboard } from '@shared/interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})
export class BiApiService {
  constructor(private readonly http: HttpClient) {}

  getAllUsers(): Observable<BaseResponse<BIUser[]>> {
    return this.http
      .get<BaseResponse<BIUser[]>>(ApiEndpoints.BIAction.GetAllUsers)
      .pipe(take(1));
  }

  getPayComponentGroup(): Observable<BaseResponse<any>> {
    return this.http
      .get<BaseResponse<any>>(ApiEndpoints.BIAction.get_pay_component_group)
      .pipe(take(1));
  }

  getDashboards(): Observable<BaseResponse<BiDashboard[]>> {
    return this.http
      .get<
        BaseResponse<BiDashboard[]>
      >(`${ApiEndpoints.BIAction.get_dashboards}`)
      .pipe(take(1));
  }

  getGuestToken(
    dashboardId: string,
  ): Observable<{ guestToken: string; csrfToken: string }> {
    return this.http
      .get<{
        guestToken: string;
        csrfToken: string;
      }>(`${ApiEndpoints.BI.get_guest_token}/${dashboardId}`)
      .pipe(take(1));
  }

  getAllLookupById(
    id: string | number,
  ): Observable<BaseResponse<LookupItem[]>> {
    return this.http
      .get<
        BaseResponse<LookupItem[]>
      >(`${ApiEndpoints.BIAction.get_all_lookup_by_id}/${id}`)
      .pipe(take(1));
  }

  getDashboardsByAccountId(accountId: number): Observable<Dashboard[]> {
    return this.http
      .get<{
        data: Dashboard[];
      }>(`${ApiEndpoints.BIGroups.getDashboardsByAccountId}/${accountId}`)
      .pipe(
        map(response => response?.data || []),
        catchError((error: HttpErrorResponse) => {
          console.error('Error loading dashboards by accountId:', error);
          return of([]);
        }),
      );
  }
}
